import { put, select, takeLatest } from 'redux-saga/effects'
import { registerWebAuthn as register } from '../api/registerWebAuthn'
import {
  registerWebAuthnSucceeded,
  registerWebAuthnFailed
} from '../../actions/setupMFAWebAuthn'
import { REGISTER_WEB_AUTHN } from '../../constants/action.types'
import { getWebAuthnRegistrationData } from '../../selectors/setupMFAWebAuthn'
import executeSaga from './helpers/executeSaga'

export function* registerWebAuthn({ request }) {
  const registrationData = yield select(getWebAuthnRegistrationData)

  yield executeSaga(
    request,
    {
      registrationData
    },
    credential => put(registerWebAuthnSucceeded({ credential })),
    error => put(registerWebAuthnFailed({ errorCode: error.message }))
  )
}

export default function*({ request } = { request: register }) {
  yield takeLatest(REGISTER_WEB_AUTHN, registerWebAuthn, { request })
}
